import React, { FC, memo } from 'react';
import { Image, ImageProps } from 'react-native';

const FastImageComponent: FC<ImageProps> = ({ ...props }) => <Image {...props} />;

export default memo(FastImageComponent);
